import { render } from "./ordentrabajoresultadoestudioec.vue?vue&type=template&id=51beb261&scoped=true"
import script from "./ordentrabajoresultadoestudioec.vue?vue&type=script&lang=js"
export * from "./ordentrabajoresultadoestudioec.vue?vue&type=script&lang=js"

import "./ordentrabajoresultadoestudioec.vue?vue&type=style&index=0&id=51beb261&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51beb261"]])

export default __exports__